import { useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

export function useRMISOnboarding() {
  const { pathname: locationPathname, search: locationSearch } = useLocation()
  const history = useHistory()

  const navigateToRMISOnboarding = useCallback(() => {
    const currentQueryParams = new URLSearchParams(locationSearch)
    currentQueryParams.set('finishOnboarding', '1')
    history.push(`${locationPathname}?${currentQueryParams.toString()}`)
  }, [history, locationPathname, locationSearch])

  return {
    navigateToRMISOnboarding,
  }
}
